
// Layouts
import { HeaderInits } from "../../layout/header/header-inits";
import { FormInits } from "../../layout/form/form-inits";
import { NavigationInits } from "../../layout/navigation/navigation-inits";
import { StructureInits } from "../../layout/structure/structure-inits";

// Components
import { BreakdownInits } from "../../components/breakdown/breakdown-inits";
import { BreakingInits } from "../../components/breaking/breaking-inits";
import { CardInits } from "../../components/card/card-inits";
import { CookieInits } from "../../components/cookie/cookie-inits";
import { GalleryInits } from "../../components/gallery/gallery-inits";
import { InterviewInits } from "../../components/interview/interview-inits";
import { QuizInits } from "../../components/quiz/quiz-inits";
import { LightboxInits } from "../../components/lightbox/lightbox-inits";
import { LivecastInits } from "../../components/livecast/livecast-inits";
import { MediaInits } from "../../components/media/media-inits";
import { RadioInits } from "../../components/radio/radio-inits";
import { ModuleInits } from "../../components/module/module-inits";
import { PageInits } from "../../components/page/page-inits";
import { PaginationInits } from "../../components/pagination/pagination-inits";
import { PollInits } from "../../components/poll/poll-inits";
import { RelationInits } from "../../components/relation/relation-inits";
import { SearchInit } from "../../components/search/search-init";
import { SessionInits } from "../../components/session/session-inits";
import { ShareInits } from "../../components/share/share-inits";
import { SoapInits } from "../../components/soap/soap-inits";
import { TvScheduleInits } from "../../components/tv-schedule/tvSchedule-inits";
import { AdvertisingInits } from "../../components/advertising/advertising-inits";

import $ from 'jquery';

class App {
    constructor() {
        this.onInit();
    }

    onInit() {
        window.jQuery = $;
        window.$ = $;

        require ("../../../libs/jquery.stuck");
        require ("../../../libs/jquery.unveil-E");

        // Layouts
        new HeaderInits();
        new FormInits();
        new NavigationInits();
        new StructureInits();

        // Components
        new BreakdownInits();
        new BreakingInits();
        new CardInits();
        new CookieInits();
        new GalleryInits();
        new InterviewInits();
        new QuizInits();
        new MediaInits();
        new RadioInits();
        new ModuleInits();
        new LightboxInits();
        new LivecastInits();
        new PageInits();
        new PaginationInits();
        new PollInits();
        new RelationInits();
        new SearchInit();
        new SessionInits();
        new ShareInits();
        new SoapInits();
        new TvScheduleInits();
        new AdvertisingInits();
    }
}

new App();
